import { IManageViewConfig } from "src/tenantConfig/interface";
import { ManageViewConstants } from "./ManageViewConstants";

//TODO migrate this to existing config file
export interface IManageViewConfiguration {
  tenantId: string;
  name: string;
  dataSource: string;
  showAddViewButton: boolean;
  showCommandBar: boolean;
  showPreviewFeatureMessageBar: boolean;
}

export interface IManageViewTextConstants {
  PreviewFeatureMessageBarTitle: string
  PreviewFeatureMessageBarText: string;
}

export const ManageViewTextConstants = {
  PreviewFeatureMessageBarTitle: 'Preview Feature',
  PreviewFeatureMessageBarText: 'Views for this tenant are currently readonly while the experience is in preview mode',
}

export const ArtemisFieldsToHide = [
  ManageViewConstants.ManageviewFields.CAPSL_AccountName,
  ManageViewConstants.ManageviewFields.CAPSL_AM_PDMName,
  ManageViewConstants.ManageviewFields.CAPSL_BusinessJustification,
  ManageViewConstants.ManageviewFields.CAPSL_ContactAlias,
  ManageViewConstants.ManageviewFields.CAPSL_FirstName,
  ManageViewConstants.ManageviewFields.CAPSL_LastName,
  ManageViewConstants.ManageviewFields.CAPSL_SuppressChildAccount,
  ManageViewConstants.ManageviewFields.CAPSL_Title
]

//export const DefaultConfigurationTenantId = 'Other'
export const DefaultConfigurationTenantId = '78b50682-9b40-4508-a421-0cff4e6e7014' //Id for UAT general tenant
export const DefaultConfigurationTenantName = 'Other' //Display name for UAT general tenant manage views tab

export const DefaultConfiguration: IManageViewConfig = {
  tenantId: DefaultConfigurationTenantId,
  showAddViewButton: true,
  showCommandBar: true,
  showPreviewFeatureMessageBar: false,
  showSelectFields: true,
};

export const DefaultSelectedTabId: string = DefaultConfigurationTenantId
